import React, {useEffect}  from 'react'
import './SecondFrame.css'
import { Images, Tools } from '../../../utils'

export default function SecondFrame(props) {  
  return (
    <div className='second-contain'>
      <img src={Images.home.secondtGif} alt='' className='second-img' />
      <div className='second-wrap'> 
          <div className='second-title'>就医经验分享与指导平台</div>
          <div className='second-sub'>
            在这里，有数万计的用户分享就医体验和就诊攻略
          </div>
      </div>    
    </div>
  );
}